import { queryOptions } from '@tanstack/react-query';

import SitesService from './sitesService';

// **** Queries **** //

export const siteQueryKeys = {
  regions: ['regions'] as const,
};

export const siteQueryOptions = {
  regions: () =>
    queryOptions({
      queryKey: siteQueryKeys.regions,
      queryFn: () => SitesService.fetchRegions(),
      // Regions rarely change and are shared across admin pages, so cache them for 5 mins.
      staleTime: 300000,
    }),
};

// **** Mutations **** //
